import React, { useEffect } from "react";
import styled from "styled-components";

// components
import SectionContainer from "core/SectionContainer";
import Faq from "core/Faq";
import TextWithButton from "core/TextWithButton";
import Button from "core/Button";
import IllustrativeHero from "core/IllustrativeHero";
import Organization from "core/ReusableIcons/Organization";
import IconsSection from "marketing-pages/PricingMarketingPage/IconsSection";
import OffsetGrid from "core/OffsetGrid";
import PageMeta from "core/PageMeta";

import {
    NOUN_PRO_TEAM_INFO_PAGE,
    NOUN_PRO_TEAM_SETTINGS_REDIRECT
} from "data/links";
import { TEAM_YEARLY_PLAN } from "subscriptions/data";

// styles
import breakpoints from "core/breakpoints";
import colors from "core/colors";
import { Image } from "./styles";

// data
import { svgSizes } from "subscriptions/data";
import {
    metaTitle,
    metaDescription,
    mainHeroTitle,
    headingTitle,
    subTextTitle,
    sections,
    heroSubTitle,
    highlightTeamColumn,
    faqTitle,
    faqValues
} from "./data";

const ButtonContainer = styled.div`
    display: flex;
    flex-direction: column-reverse;
    row-gap: 1rem;
    max-width: 440px;
    margin: 1rem auto;

    @media (min-width: ${breakpoints.tablet.rem}) {
        flex-direction: row;
        column-gap: 1rem;
        margin: 2rem auto;

        ${Button} {
            flex: 1;
        }
    }
`;

const NounProTeam = () => {
    useEffect(() => {
        // We need to manually take control of the browsers scrollRestoration
        window.history.scrollRestoration = "manual";

        if (window.pageYOffset !== 0) {
            window.scrollTo(0, 0);
        }
    }, []);

    return (
        <>
            <PageMeta
                title={metaTitle}
                indexContent="index,follow"
                description={metaDescription}
            />
            <SectionContainer bgColor={colors.secondary.orca}>
                <Image alignment="center">
                    <Organization
                        size={svgSizes}
                        fillColor={colors.primary.diamond}
                    />
                </Image>
                <TextWithButton
                    headingColor={colors.primary.diamond}
                    headingAlignment="center"
                    headingType="h1"
                    headingSize="3xl"
                    headingBottomSpacing="xl"
                    subtextColor={colors.primary.diamond}
                    text={mainHeroTitle}
                    subtext={heroSubTitle}
                >
                    <ButtonContainer>
                        <Button
                            key="manage-existing-team"
                            href={NOUN_PRO_TEAM_SETTINGS_REDIRECT}
                            styleType="outline"
                            size="lg"
                            darkMode={true}
                        >
                            Manage Existing Team
                        </Button>
                        <Button
                            key="get-started"
                            href={NOUN_PRO_TEAM_INFO_PAGE.replace(
                                ":planType",
                                TEAM_YEARLY_PLAN
                            )}
                            size="lg"
                            darkMode={true}
                        >
                            Get Started
                        </Button>
                    </ButtonContainer>
                </TextWithButton>
            </SectionContainer>

            <SectionContainer bgColor={colors.primary.diamond}>
                <OffsetGrid sm={10} md={12} lg={12}>
                    <TextWithButton
                        text={headingTitle}
                        subtext={subTextTitle}
                        headingAlignment="center"
                        subtextAlignment="center"
                        bottomSpacing="xl"
                        headingType="h2"
                        headingSize="xl"
                    />
                    <IllustrativeHero sections={sections} alignment="center" />
                </OffsetGrid>
            </SectionContainer>

            <IconsSection bestValueHighlight={highlightTeamColumn} />

            <SectionContainer bgColor={colors.primary.diamond}>
                <OffsetGrid sm={10} md={12} lg={12}>
                    <Faq
                        title={faqTitle}
                        values={faqValues}
                        headingAlignment="left"
                    />
                </OffsetGrid>
            </SectionContainer>
        </>
    );
};

export default NounProTeam;
